import { ViewModel,View, ObservableArray } from "binder"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class PersonSearchViewModel extends SearchableSelectorBaseViewModel<person>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    
    protected async loadData(searchedText: string): Promise<person[]> {
        let result = await ServerConnection.callServer('Complex/ArapRawDataServices/SearchPerson',{
            SearchText:searchedText,
            ResultCount:20
        });
        return result.Persons.map(x=>this.convertSingle(x));
    }
    protected async loadById(id: string): Promise<person> {
        let result = await ServerConnection.callServer('Complex/ArapRawDataServices/SearchPersonById',{
            Id:id
        });    
        return this.convertSingle(result.Person);
    }
    
    private convertSingle(dto:any):person{
        var p = new person(this);
        p.id = dto.Id;
        p.name = dto.Name;
        p.code = dto.Code;
        p.title = `${p.name}(${p.code})`;
        return p;
    }
}

export class person extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    
}
